<!--最终导入，设置是哪个成绩单中的数据-->
<template>
  <div>
    <el-row>
      <el-col :span="24">
        <Header></Header>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="4">
        <MenuList></MenuList>
      </el-col>
      <el-col :span="20">
        <div style="padding: 10px;">
          <div class="actionBarStyle">
            <el-row>
              <div class="searchStyle">
                <!-- <el-button type="primary" plain @click="back">上一步</el-button> -->
                <el-button type="primary" @click="dialogFormVisible=true">下一步</el-button>
              </div>
            </el-row>
            <div style="color:red;display: flex;align-items: center;font-size: 18px;">以下是要导入的成绩,如无误点左侧“下一步”按钮导入成绩</div>
            <div style="padding: 10px;color:red;font-size: 16px;">共{{tableData.length}}条数据</div>
          </div>
        </div>
        <div style="padding: 10px;">

          <div>
            <el-table :data="top100RowData" height="500" style="width: 100%"
              :header-cell-style="{background:'#eef1f6',color:'#606266'}">
              <!--              <el-table-column type="index" fixed label="序号" width="80" :index="indexMethod" style="background:'#eef1f6',color:'#606266'">
              </el-table-column> -->
              <el-table-column header-align="center" align="center" :key="col"
                :label="convertLable(realColumNames[index],index)" :prop="col" v-for="(col,index) in columNames">
              </el-table-column>

<!--              <el-table-column label="操作" header-align="center" align="center" fixed="right">
                <template slot-scope="scope">
                  <el-button @click.native.prevent="delFinalData(scope.$index, tableData)" type="text" size="small">
                    删除
                  </el-button>
                </template>
              </el-table-column> -->

            </el-table>

            <el-row>
              <div class="searchStyle" style="margin-top: 20px;color:red;width:100%;">
                共{{tableData.length}}条数据<span v-if="tableData.length>100">，为了快速预览，此处只显示前100条，但不影响数据导入。</span>
              </div>
            </el-row>

            <el-row>
              <div class="searchStyle" style="margin-top: 20px;">
                <!-- <el-button type="primary" plain @click="back">上一步</el-button> -->
                <el-button type="primary" @click="dialogFormVisible=true">下一步</el-button>
              </div>
            </el-row>
          </div>

        </div>

      </el-col>
    </el-row>
    <el-dialog :close-on-click-modal="false" width="20%" v-dialogDrag title="操作提醒" :visible.sync="dialogFormVisible">
      <el-form :model="form">
       <div>数据无误，确认导入吗？</div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="nextStep">立即导入</el-button>
      </div>
    </el-dialog>

    <!--重复列名提示信息-->
    <el-dialog :close-on-click-modal="false" width="35%" v-dialogDrag title="列名重复,合并失败!"
      :visible.sync="dialogMergeVisible">
      <div>
        重复的列名如下：
      </div>
      <div>
        {{duplicate_columns}}
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeMergeDialog">关 闭</el-button>
        <!-- <el-button type="primary" @click="nextStep">立即导入</el-button> -->
      </div>
    </el-dialog>

  </div>
</template>

<script>
  import MenuList from './menu.vue'
  import Header from './head.vue'
  import '../assets/global.css'

  export default {
    components: {
      MenuList,
      Header
    },
    data() {
      return {
        username: '',
        tableData: [],
        top100RowData: [],
        cols: ['', '', '', ''],
        id: '',
        dialogVisible: false,
        searchResultSettingDialogTableVisible: false,
        position: -1,
        selectedExamID: '',
        msg: '',
        configurations: [],
        showPosition: false,

        num: 0,
        columNames: [],
        realColumNames: [],
        selectedColumnNames: [],
        columnCount: 0,
        dialogFormVisible: false,
        form: {},
        jsList: '',
        colList: '',
        exam: '',
        grade: '',
        paperScoreList: '',
        realPaperScores: [],

        exam_type: '1',
        last_exam: '',
        last_exam_key: '',
        currentClass: 'enableExamForm',
        exam_selected_type: '1',
        import_type: 'NEW_EXAM',

        dialogMergeVisible: false,
        duplicate_columns: '',

        exam_id:''

      }
    },
    created() {
      // 返回的是全量数据和全量列
      this.jsList = JSON.parse(decodeURIComponent(this.$route.params.jsList))
      this.colList = JSON.parse(decodeURIComponent(this.$route.params.colList)) // xx成绩，xx排名
      this.paperScoreList = JSON.parse(decodeURIComponent(this.$route.params.paperScoreList))
      console.log(this.paperScoreList)

      for (var i = 0; i < this.colList.length; i++) {
        if (this.colList[i] !== '不导本列') {
          this.columNames.push('第' + (i) + '列')

          this.realColumNames.push(this.colList[i]) // 选中的列，不含空格
          this.realPaperScores.push(this.paperScoreList[i])
        }
      }

      // console.log(this.realPaperScores)

      this.username = this.$session.get('USERNAME') // 获取session
      console.log('登录用户：' + this.username)

      this.exam_id = this.$route.params.exam_id

      console.log('登录用户：' + this.username      + '******************' + this.exam_id)

      this.tableData = this.jsList
      this.top100RowData = this.tableData.slice(0, 99)
      console.log('this.tableData', this.tableData)

      this.loadNewestExam()
    },
    methods: {

      indexMethod(index) {
        var tmpIndex = this.tableData.length - index
        return tmpIndex
      },
      loadCourses() {
        let that = this
        var requestUrl = '/score/web/_get_courses.jsp'

        this.axios.get(requestUrl).then(function(response) {
            // that.columNames.push(...response.data)

            console.log(response.data)
            for (var i = 0; i < response.data.length; i++) {
              var tmpObj = {
                'course_name': response.data[i].course_name
              }

              // if (tmpObj.course_name !== '总分' && tmpObj.course_name.indexOf('排名') <= 0) {
              //   tmpObj.course_name = tmpObj.course_name + '成绩'
              // }

              that.columNames.push(tmpObj)
            }
          })
          .catch(function(error) {
            console.log(error)
          })
      },
      nextStep() {
        // if (this.exam_selected_type == '') {
        //   this.$message.error('请选择是新建成绩单还是要合并')
        //   return
        // }

        // if (this.import_type == 'NEW_EXAM') {
        //   // 校验
        //   if (this.exam === '') {
        //     this.$message.error('输入考试名称')
        //     return
        //   }

        //   if (this.grade === '') {
        //     this.$message.error('输入年级班级')
        //     return
        //   }
        // }

        this.username = this.$session.get('USERNAME')

        let that = this
        var requestUrl = '/score/web/_team_import__excel.jsp'

        console.log('that.jsList')
        console.log(that.jsList)

        that.import_type='3'

        let data = {
          jsList: JSON.stringify(that.jsList),
          colList: JSON.stringify(that.colList),
          paperScoreList: JSON.stringify(that.paperScoreList),
          exam: that.exam,
          grade: that.grade,
          username: that.username,
          import_type: that.import_type,
          exam_key: that.exam_id
        }

        // console.log('&&&&&&&' + that.username)

        var qs = require('qs')

        // 开启loading
        const load = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        this.axios.post(
            requestUrl,
            qs.stringify(data), {
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
              }
            }
          ).then(function(response) {
            console.log(response.data)

            if (response.data.result == '-1') {
              that.$message.error('长时间未操作，请登录后重新操作！')
              load.close()
              that.$router.push('/')
            } else if (response.data.result == '-2') {
              that.$message.error('数据中有表头，导入失败，请重试！')
              load.close()
              that.$router.push('/team_exam_list')
            } else if (response.data.result == '-3') {
              that.duplicate_columns = response.data.duplate_cols
              that.dialogMergeVisible = true
              // that.alert('有重复的列,合并失败！重复的列是：' +  response.data.duplate_cols )
              // that.$message.error('有重复的列,合并失败！')
              load.close()
              // that.$router.push('/exam_list')
            } else {
              that.$message.success('导入成功！')
              load.close()

              that.$router.push({
                name: 'team_exam_list',
                params: {
                  shownotify: 1
                }
              })

              // that.$router.push({path: '/exam_list', query: {shownotify: 1}})
              // that.$router.push('/exam_list?shownotify=1')
            }
          })
          .catch(function(error) {
            console.log(error)
            load.close()
          })

        this.dialogFormVisible = false
      },
      changeStatus(val, index) {
        console.log(val + index)
      },
      back() {
        this.$router.back()
      },
      delFinalData(i, tableData) {
        this.tableData.splice(i, 1)
      },
      convertLable(lableName, index) {
        if (lableName.indexOf('成绩') > 0) {
          return lableName.replace('成绩', '') + '(' + this.realPaperScores[index] + '分)'
        } else {
          return lableName
        }
      },
      loadNewestExam() {
        let that = this
        var requestUrl = '/score/web/_get_last_exam.jsp'

        this.axios.get(requestUrl, {
            params: {
              username: that.username
            }
          }).then(function(response) {
            console.log('_get_last_exam.jsp', response.data)
            if (response.data.result == '1') {
              that.last_exam = response.data.exam
              that.last_exam_key = response.data.exam_key
            } else {
              that.last_exam = ''
              that.last_exam_key = -1
            }
          })
          .catch(function(error) {
            console.log(error)
          })
      },
      selectExamRadio(exam_type) {
        console.log(exam_type)
        if (exam_type === '1') {
          this.currentClass = 'enableExamForm'
          this.import_type = 'NEW_EXAM'
        } else if(exam_type === '3'){
          this.currentClass = 'disableExamForm'
          this.import_type = 'MERGE_EXAM'
        }else if(exam_type === '2'){
          this.currentClass = 'disableExamForm'
          this.import_type = 'APPEND_SCORE'
        }
      },
      selectNewExamRadio() {
        this.exam_type = '1'
      },
      closeMergeDialog() {
        this.dialogMergeVisible = false
        this.$router.push('/exam_list')
      }

    }
  }
</script>

<style>
  .actionStyle {
    display: flex;
    flex-direction: column;

  }

  :header-cell-style: {
    background: '#E9EEF5';
    color: '#000'
  }

  .actionBarStyle {
    display: flex;
    justify-content: space-between;
  }

  .rowStyle {
    display: flex;
    justify-content: space-between;
  }

  .rowBtnStyle {
    display: flex;
    justify-content: flex-end;
    padding-top: 50upx;
  }

  .settingRowStyle {
    display: flex;
    justify-content: space-between;
    flex-direction: row;
    border: 1px solid aliceblue;
    margin: 5px;
  }

  .rowContentStyle {
    display: flex;
    align-items: center;
    padding-top: 20px;
    padding-bottom: 20px;
    padding-left: 20px;
  }

  .settingFormStyle {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

  .el-scrollbar__wrap {
    overflow-x: hidden;
  }

  .disableExamForm {
    pointer-events: none;
    color: #AAAAAA;
    width: 100%;
  }

  .enableExamForm {
    color: #000000;
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/team_exam_excel_final_preview.vue